import React from "react";

class LanguageSelector extends React.Component {

    chooseLanguageEn = () => {
        this.props.language("en");
    }

    chooseLanguageEs = () => {
        this.props.language("es");
    }

    chooseLanguageBg = () => {
        this.props.language("bg");
    }

    render() {
        return (
            <div className="language-selector">
                <img id="language-en" className="language-icon" onClick={this.chooseLanguageEn} src="./en.png" alt="English Language"></img>
                <img id="language-es" className="language-icon" onClick={this.chooseLanguageEs} src="./es.png" alt="Spanish Language"></img>
                <img id="language-bg" className="language-icon" onClick={this.chooseLanguageBg} src="./bg.png" alt="Bulgarian Language"></img>
            </div>
        );
    }

}

export default LanguageSelector;